import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { ContextLibraryTagType, QueryContextLibraryUploadedFilesArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryContextLibraryUploadedFilesArgs;
type TData = Array<ContextLibraryTagType>;

export type ContextLibraryData = TData;

const MOCK: TVariables = {
  id: undefined,
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  query: undefined,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined,
  tagId: undefined
};

export const useContextLibraryTags = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query contextLibraryTags {
      contextLibraryTags {
        id
        name
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useContextLibraryTags', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
